module.exports = __webpack_public_path__ + "img/9788925546520.bd985e71.jpg";